import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DetailsSummary from 'components/DetailsPanels/DetailsSummary';

class DetailsSummaryContainer extends Component {
  static propTypes = {
    entityDefinitions: PropTypes.any,
    entityType: PropTypes.string,
    entity: PropTypes.any
  };

  getEntityDefinition = ({ defs, entityType }) => {
    return defs.find(x => x.id === entityType);
  };

  render() {
    let dictionaryNode = this.getEntityDefinition({
      defs: this.props.entityDefinitions.defs,
      entityType: this.props.entityType
    });

    return ( dictionaryNode
      ?
      <DetailsSummary
        entity={this.props.entity}
        dictionaryNode={dictionaryNode}
      />
      : <div></div>
    );
  }
}

export default connect(
  state => ({
    entityDefinitions: state.entityDefinitions
  })
)(DetailsSummaryContainer);
